export default __webpack_public_path__ + "static/staffpass-2-cecb960469a71eac8fa29e79a462a764.png";